// extracted by mini-css-extract-plugin
export var errorsContainer = "_uv-1";
export var link = "_uv-0";